import React from 'react'
import Container from '@mui/material/Container'

import DataPalBanner from '~/client/components/DataPalBanner'
import SideNote from '~/client/components/SideNote'

export default function DashboardPage() {
  return <Container sx={{mt: 2, p: 4, maxWidth: 'sm'}}>
    <DataPalBanner sx={{m: 0, maxWidth: 'min(100px, 30vw)'}}/>
    <SideNote>
        <p>Welcome to the DataPal Personal Data Management Service.​</p>
        <p>DataPal enables you to CONTROL your personal information and SHARE it with connections that you trust to use it responsibly.​</p>
        <p>You can enter as much, or as little, data as you wish. Only you can access anything that you have entered, unless you choose to share it under the terms of an Information Sharing Agreement.​</p>
        <p>Any changes that you make to your data, or the connections with which you wish to share it, are recorded in your history folder.​</p>
    </SideNote>
  </Container>
}
